import { render, staticRenderFns } from "./AddSupportRequest.vue?vue&type=template&id=cc2b8480&scoped=true"
import script from "../controllers/AddSupportRequest.ts?vue&type=script&lang=ts&external"
export * from "../controllers/AddSupportRequest.ts?vue&type=script&lang=ts&external"
import style0 from "./AddSupportRequest.vue?vue&type=style&index=0&id=cc2b8480&prod&lang=scss&scoped=true"
import style1 from "./AddSupportRequest.vue?vue&type=style&index=1&id=cc2b8480&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2b8480",
  null
  
)

export default component.exports